import { Modal, Stack, styled, Typography } from '@mui/material';
import Spinner from '../Spinner';

const StyledTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontWeight: theme.typography.h4.fontWeight,
  fontSize: theme.typography.availableBalance.fontSize,
  textAlign: 'center',
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.typography.button.fontSize,
  },
}));
const TextTypography = styled(Typography)(({ theme }) => ({
  marginTop: '20px',
  color: theme.palette.primary.main,
  fontWeight: theme.typography.littleText.fontWeight,
  fontSize: theme.typography.button.fontSize,
  textAlign: 'center',
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.typography.button.fontSize,
  },
}));

const ModalWrapper = styled(Stack)({
  height: '100%',
  justifyContent: 'center',
  alignItems: 'center',
  overflowY: 'auto',
});

const ModalContent = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.white.main,
  width: '36%',
  borderRadius: '12px',
  boxShadow: '0px 10px 15px -3px rgba(0,0,0,0.1)',
  padding: '30px',
  boxSizing: 'border-box',
  maxHeight: '90vh',
  overflowY: 'auto',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-evenly',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: '30px',
  [theme.breakpoints.down('md')]: {
    width: '60%',
    padding: '30px',
  },
  [theme.breakpoints.down('sm')]: {
    width: '90%',
    padding: '20px',
  },
}));

export const InvestmentPortfolioModal = ({ open, onClose }) => {
  return (
    <>
      <Modal open={open} onClose={onClose}>
        <ModalWrapper>
          <ModalContent>
            <Stack>
              <Spinner />
            </Stack>
            <Stack marginTop={'10px'}>
              <StyledTypography>Estamos generando tu transacción...</StyledTypography>
              <TextTypography>
                Esto puede tardar unos segundos. Por favor, no cierres ni recargues la página.
              </TextTypography>
            </Stack>
          </ModalContent>
        </ModalWrapper>
      </Modal>
    </>
  );
};
